import FileUploaderDialog from './FileUploaderDialog';

export default FileUploaderDialog;
